import { render, staticRenderFns } from "./WorkoutEditor.vue?vue&type=template&id=2b7771c8&scoped=true&"
import script from "./WorkoutEditor.vue?vue&type=script&lang=js&"
export * from "./WorkoutEditor.vue?vue&type=script&lang=js&"
import style0 from "./WorkoutEditor.vue?vue&type=style&index=0&id=2b7771c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7771c8",
  null
  
)

export default component.exports